import { makeGuardedModal } from 'components/guardedModal/makeGuardedModal';
import { SimpleModalId } from 'constants/modalId';
import { UnlockTemplateModalContentContainer } from './UnlolckTemplateModalContentContainer';

export const UnlockTemplatetModal = makeGuardedModal(SimpleModalId.UnlockTemplate, UnlockTemplateModalContentContainer);
